<h2 mat-dialog-title>Delete Conversation?</h2>
<mat-dialog-content class="mat-typography">
  <p> Are you sure you want to delete full conversation? </p>
  <ul>
    <li>Click <b>Delete</b> to delete current messages</li>
    <li>Click <b>Delete & Block</b> to delete and block new messages from recipient</li>
  </ul>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button color="warn" [mat-dialog-close]="1" cdkFocusInitial>Delete</button>
  <button mat-button color="warn" [mat-dialog-close]="2">Delete & Block</button>
</mat-dialog-actions>
